import React, { useCallback } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import { useRouter } from 'expo-router';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';
import { trackEvent } from '@/constants/utils/analytics';

const ExploreCategoriesRouteNavigationHeaderRight = React.memo(() => {
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();
  const router = useRouter();

  const handleCategoriesClick = useCallback((e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    trackEvent('explore', 'explore_categories_header_categories_click');
    router.push('/explore/categories');
  }, [router]);

  const categoriesLabel = t('explore.browseCategories') || 'Categories';

  return (
    <NavigationBarButtonContainer rightPadding>
      <NavigationBarButton
        label={isXS ? undefined : categoriesLabel}
        icon={isXS ? 'layer-group' : undefined}
        tooltip={isXS ? categoriesLabel : undefined}
        appendIcon="angle-right"
        appendIconSize={10}
        variant="transparent"
        onPress={handleCategoriesClick}
      />
    </NavigationBarButtonContainer>
  );
});

ExploreCategoriesRouteNavigationHeaderRight.displayName = 'ExploreCategoriesRouteNavigationHeaderRight';

const ExploreCategoriesRouteNavigationOptions = {
  title: 'Explore Categories',
  headerTitle: 'Categories',
  headerBackVisible: true,
  headerRight: () => <ExploreCategoriesRouteNavigationHeaderRight />,
};

export default ExploreCategoriesRouteNavigationOptions;
